<h4 style="text-align: center;" class="mt-0">
  {{ 'printers.delete_question' | translate }}
</h4>
<div style="display: flex; justify-content: center">
  <button class="btn btn-fill btn-danger" (click)="submit()">
    {{ 'printers.confirm' | translate }}
  </button>
</div>

